import { useSearchParams } from "react-router-dom";
import { Alert as AntAlert } from "antd";
import { capitalize } from "../../utils/utils";

export const columns = [
  {
    title: "No. Orden",
    dataIndex: "codigoPedido",
    key: "codigoPedido",
  },
  {
    title: "Cliente",
    dataIndex: "cliente",
    key: "cliente",
  },
  {
    title: "Punto de Venta",
    dataIndex: "puntoVenta",
    key: "puntoVenta",
  },
  {
    title: "Producto",
    dataIndex: "producto",
    key: "producto",
  },
  {
    title: "Cant.",
    dataIndex: "cantidad",
    key: "cantidad",
  },
  {
    title: "Estado Orden",
    dataIndex: "estado",
    key: "estado",
    render: (_, record) => (
      <span>
        {capitalize(record.estado.toUpperCase().replace(/_/g, " "))}
      </span>
    ),
  },
  {
    title: "Último Evento",
    dataIndex: "ultimoEvento",
    key: "ultimoEvento",
    render: (_, record) => (
      <span>
        {capitalize(record.ultimoEvento.toUpperCase().replace(/_/g, " "))}
      </span>
    ),
  },
  {
    title: "Causa",
    dataIndex: "causa",
    key: "causa",
    width: 400,
  },
  {
    title: "Fecha Pedido",
    dataIndex: "fechaPedido",
    key: "fechaPedido",
  },
  {
    title: "Fecha Promesa",
    dataIndex: "fechaPromesa",
    key: "fechaPromesa",
  },
  {
    title: "Fecha Entrega",
    dataIndex: "fechaEntrega",
    key: "fechaEntrega",
  },
  {
    title: "Cédula",
    dataIndex: "cedula",
    key: "cedula",
  },
  {
    title: "Nombre",
    dataIndex: "nombreSubCliente",
    key: "nombreSubCliente",
  },
  {
    title: "Última LLamada",
    dataIndex: "ultimaLlamada",
    key: "ultimaLlamada",
  },
];

export const InconsistentMsg = ({count, onClick}) => {
  return (
    <AntAlert
      message={
        <>
          Existen <b>{count}</b> pedidos que presentan Incosistencia. Haz
          click en corregir para resolverlas.
        </>
      }
      type="error"
      showIcon
      onClick={onClick}
    />
  );
};

export const LogisticAlertMsg = ({count, onClick}) => {
  return (
    <AntAlert
      message={
        <>
          Existen <b>{count}</b> pedidos que presentan Incosistencia. Haz click
          en corregir para resolverlas.
        </>
      }
      type="warning"
      showIcon
      onClick={onClick}
    />
  );
};

export function useQueryParams (params) {
  const [searchParams, setSearchParams] = useSearchParams();
  setSearchParams({...searchParams, params})

}
